import React, { useCallback, useContext, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Loading, Toast } from "../../../../components";
import classNames from "classnames/bind";
import { Link } from "react-router-dom";
import { Previous } from "../../../../components/Icons/Icons";
import FormAdd from "./FormAdd";
import ListRoleSelect from "../ListRole/ListRoleSelect";
import { role } from "../../../../services/api/RoleApi";
import styles from "./AddRole.module.css";
import { AddNewUserContext } from "../../../../contexts";

const cx = classNames.bind(styles);
const AddRole = ({ setNewCodeRole, onAddRole }) => {
  const navigate = useNavigate();
  const prams = useParams();
  const [newRole, setNewRole] = useState({
    subject_name: "",
    note: "",
  });
  const [listRole, setListRole] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const onChangeUserTypeCode = (data) => {
    setIsRefresh(!isRefresh);
  };
  const handleReturn = () => {
    if (onAddRole) {
      onAddRole()
    } else {
      navigate(-1);
    }
  };
  const handleAddRole = () => {
    setLoading(!loading)
    async function addRole() {
      const listData = listRole?.map(item => {
        return {
          ...item,
          NOTE: newRole.note,
        }
      })
      try {
        if (newRole.subject_name && newRole.subject_name !== "") {
          const data = {
            ...newRole,
            company_code: sessionStorage.getItem("company_code"),
            list_permissions: {
              data: listData,
            },
          };
          const res = await role.newRole(JSON.stringify(data));
          if (setNewCodeRole) {
            setNewCodeRole(res.user_type_code)
            handleReturn()
          } else {
            Toast.open("Thêm quyền thành công", "success");
            handleReturn();
          }
        } else {
          Toast.open("Vui lòng nhập tên quyền mới", "danger");
        }
        setLoading(false)
      } catch (e) {
        setLoading(false)
        if (e?.response?.status === 403) {
          Toast.open("Bạn không có quyền thêm quyền người dùng", "danger");
        } else if (e?.response?.status === 500 && listData.length === 0) {
          Toast.open("Bạn chưa chọn chức năng", "danger");
        } else {
          Toast.open("Thêm quyền người dùng không thành công", "danger");
        }
      }
    }
    addRole();
  };
  const listPermission = []

  return (
    <>
      <div className={cx("container")}>
        <div className={cx("header")}>
          <Link style={{ textDecoration: "none" }} onClick={handleReturn}>
            <span className={cx("icon")}>
              <Previous />
            </span>
          </Link>
          <h1 className={cx("title")}>Thêm mới quyền</h1>
        </div>
        <div className={cx("content")}>
          <div className={cx("item_add")}>
            <FormAdd
              newRole={newRole}
              setNewRole={setNewRole}
              action="add"
              onChange={onChangeUserTypeCode}
            />
          </div>
          <div className={cx("item-user")}>
            <ListRoleSelect
              role={listRole}
              setRole={setListRole}
              title={"Danh sách chức năng"}
              type="Thêm"
              userType={prams.id}
              listPermission={listPermission}
            />
          </div>
        </div>
        <div className={cx("footer")}>
          <button onClick={handleAddRole} className={cx("btn-add")}>
            Xác nhận
          </button>
          <button onClick={handleReturn} className={cx("btn-cancel")}>
            Hủy bỏ
          </button>
        </div>
      </div>
      {
        loading && (
          <div className={cx('loading-modal')}>
            <Loading />
          </div>
        )
      }
    </>
  );
};

export default AddRole;
